import {
  CompanyFactKey,
  CompanyFactSchemaVersion,
  ConflictStrategy,
  type FactKeyConfig,
} from '../core'

export const ROLE_SPECIFIC_INFO_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  [CompanyFactKey.ROLE_SCHEDULE_AND_PAY]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Schedule & Pay',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
    purposeTooltip:
      'One entry per shift, capturing that shift\'s schedule and pay together (e.g. "M–F 7a–3p · $24.50/hr · 30-min unpaid lunch"). Keeps pay tied to its schedule. Replaces the separate Schedule and Pay rate info facts.',
  },
  [CompanyFactKey.ROLE_PHYSICAL_REQUIREMENTS]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Physical requirements',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
  [CompanyFactKey.ROLE_SOFT_SKILLS]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Soft skills',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
  [CompanyFactKey.ROLE_EQUIPMENT]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Equipment',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
  [CompanyFactKey.ROLE_LANGUAGE]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Language',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
  [CompanyFactKey.ROLE_GENDER_PREFERENCE]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Gender preference',
    conflictStrategy: ConflictStrategy.REPLACE,
  },
  [CompanyFactKey.ROLE_DISCOVERY_NOTES]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Notes',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
}
